exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-group-control .card-title>a.collapsed[data-v-2d895292]:before{content:\"\\E9CA\"!important;content:\"\\E9B8\"}.card-group-control .card-title>a[data-v-2d895292]:before{content:\"\\E9C9\"!important}.daylink[data-v-2d895292]:before{left:0!important}.alternating tr[data-v-2d895292]{border-top:1px solid #ccc}.alternating tr[data-v-2d895292]:first-child{border-top:1px solid #fff}.custom-table-text[data-v-2d895292]{font-size:14px;height:40px}.smaller-text[data-v-2d895292]{font-size:12px}@media screen and (max-width:768px){.custom-table-text[data-v-2d895292]{font-size:10px}}.select_container[data-v-2d895292]{width:100%}.select2-results__option[aria-selected=true][data-v-2d895292]{background-color:#fff!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2d895292","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/shift/team-scheduling.vue
// module id = 1095
// module chunks = 0